import { color, typography } from '@primer-io/goat';
import styled from 'styled-components';

export const Header = styled.h2`
  ${typography('header-medium')};
  color: ${color('gray-900')};
  margin: 0;
`;
